import React from 'react'
import { Tooltip, TooltipData } from '../Tooltip'
import { identity } from 'lodash-es'


export type MultiChartTooltipDatum = {
  label: React.ReactNode
  color: string
  value: React.ReactNode
}

export type MultiChartTooltipData = {
  label: React.ReactNode
  data: MultiChartTooltipDatum[]
}


export const MultiChartTooltip = ({
  tooltipData
}: {
  tooltipData: MultiChartTooltipData
}) => {
  return (
    <Tooltip tooltipData={tooltipData as TooltipData} valueFormatter={identity} />
  )
}
